import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { IAlertListInfo } from '../../ts/models/IAlertInfo';
import { GetAlertRequest, IGetAlertResult } from '../../ts/ServerApi/requests/GetAlertRequest';
import { GetUserAlertCountRequest, IGetUserAlertCountResult } from '../../ts/ServerApi/requests/GetUserAlertCountRequest';
import { GetUserAlertListRequest, IGetUserAlertListResult } from '../../ts/ServerApi/requests/GetUserAlertListRequest';
import { ServerService } from '../../ts/services/ServerService';
import { ServiceLocator } from '../../app/ServiceLocator';
import { toNativePromise } from '../../commonInfra/utils/QUtils';

export namespace Alerts {

  function getServerService() {
    return ServiceLocator.get<ServerService>('ServerService');
  }

  export function getCount(): Promise<number> {
    return toNativePromise(
      getServerService().sendRequest(new GetUserAlertCountRequest())
        .then((result: IGetUserAlertCountResult) => {
          return result.totalCount;
        })
    );
  }

  export function getList(): Promise<IAlertListInfo> {
    return toNativePromise(
      getServerService().sendRequest(new GetUserAlertListRequest())
        .then((result: IGetUserAlertListResult) => {
          return ServerApiMapper.alertList(result);
        })
    );
  }

  export function getForType(type: string, id: string): Promise<IAlertListInfo> {
    return toNativePromise(
      getServerService().sendRequest(new GetAlertRequest({
        targetType: type,
        targetId: id
      })).then((result: IGetAlertResult) => {
        return ServerApiMapper.alertList(result);
      })
    );
  }

}
